import { Outlet, createFileRoute } from '@tanstack/react-router';

import { VideoTypePage } from '@/pages/record-and-send/shell/video-type-page';

function VideoTypeLayout() {
	const { videoTypeId } = Route.useParams();
	return (
		<VideoTypePage videoTypeId={videoTypeId}>
			<Outlet />
		</VideoTypePage>
	);
}

export const Route = createFileRoute('/_authenticated/_app/record-and-send/video-types/$videoTypeId')({
	component: VideoTypeLayout,
});
